var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame54(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 66,
    viewBox: "0 0 54 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8698 15.3158L38.1308 44.8002C37.8119 44.7334 37.4869 44.6838 37.1567 44.6523L43.8057 15.1027L44.8698 15.3158Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22416 9.22338H1.20729L3.22416 7.20693V9.22338Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58621 12.0862H6.08621V11.5862V6.5H16.2586V27.8449H0.5V12.0862H5.58621ZM13.0345 26.9828H13.5345V26.4828V20.8966V20.3966H13.0345H11.1724H10.6724V20.8966V24.1207H4.22414V19.6959L4.57423 20.046L7.09473 22.5665L7.4483 22.92L7.80185 22.5664L14.9769 15.3908L15.3304 15.0372L14.9769 14.6837L13.6605 13.3673L13.307 13.0138L12.9534 13.3673L7.44817 18.8726L6.59809 18.0225L6.24459 17.669L5.89104 18.0225L4.57429 19.3388L4.22414 19.6888V16.7414H6.51725H7.01725V16.2414V14.3793V13.8793H6.51725H1.86207H1.36207V14.3793V26.4828V26.9828H1.86207H13.0345Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4428 44.6859L28.5851 49.1142C28.1205 49.9355 27.7857 50.8381 27.6019 51.7936L5.57966 47.7162L5.57952 47.7161C5.33359 47.6707 5.15527 47.4559 5.15527 47.2062C5.15527 47.1659 5.16038 47.1211 5.17077 47.0761L5.58606 45.4155L5.64213 45.1922C5.72924 44.8453 6.0946 44.6153 6.44146 44.6856L6.4428 44.6859Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1209 24.8762L20.4418 25.1408L19.1209 29.7633V24.8762ZM37.8315 28.6184L34.1763 44.8647C32.8789 45.1864 31.6976 45.7973 30.6966 46.6176L8.22547 42.1235L10.7069 30.706H18.6209H18.8515L18.8292 30.784L18.6802 31.3054L19.2119 31.4117L30.3545 33.6396L30.8067 33.73L30.9333 33.2867L32.5682 27.5656L37.8315 28.6184Z",
    fill: "white",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2849 29.1091L23.2572 25.7044L25.0964 26.0726L24.1234 29.4765L22.2849 29.1091Z",
    fill: "white",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8484 10.4703L52.7576 12.052C53.1881 12.1387 53.5004 12.5199 53.5001 12.9568V12.9571C53.5001 13.4639 53.0861 13.8786 52.5786 13.8786H52.3708C52.3056 13.8786 52.2458 13.8727 52.1939 13.862L52.1939 13.862L52.1904 13.8613L44.4343 12.31L44.8484 10.4703Z",
    fill: "white",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2119 41.6129L42.0513 46.7199C41.6704 46.3948 41.2619 46.101 40.8283 45.8432L41.8572 41.3424L43.2119 41.6129Z",
    fill: "white",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6028 53.4826C38.6028 54.7488 37.576 55.7756 36.3097 55.7756C35.0434 55.7756 34.0166 54.7488 34.0166 53.4826C34.0166 52.2161 35.0433 51.1897 36.3097 51.1897C37.5761 51.1897 38.6028 52.2161 38.6028 53.4826Z",
    fill: "white",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9726 29.4599L45.7886 30.2699L44.4476 30.0016L45.0086 27.5475L45.9726 29.4599Z",
    fill: "white",
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2939 53.483C30.2939 50.166 32.9945 47.4653 36.3112 47.4653C39.6279 47.4653 42.3284 50.166 42.3284 53.483C42.3284 56.7999 39.6279 59.5006 36.3112 59.5006C32.9945 59.5006 30.2939 56.7999 30.2939 53.483ZM31.156 53.483C31.156 56.3262 33.468 58.6384 36.3112 58.6384C39.1544 58.6384 41.4664 56.3258 41.4664 53.483C41.4664 50.6397 39.1544 48.3275 36.3112 48.3275C33.468 48.3275 31.156 50.6397 31.156 53.483Z",
    fill: "white",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1542 33.0633L43.8452 38.8213L42.4945 38.5512L43.8099 32.7948L45.1542 33.0633Z",
    fill: "white",
    stroke: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9402 30.04L27.9125 26.6353L29.7517 27.0036L28.7794 30.4074L26.9402 30.04Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame54);
export default __webpack_public_path__ + "static/media/Frame 54.99b9fb6d346cde697ed275b56d7b79d7.svg";
export { ForwardRef as ReactComponent };